import React from 'react';
import { Outlet } from 'react-router-dom';
import HistoricalSideNavContainer from '@modules/members/historical-applications/HistoricalSideNavContainer';
import { HISTORICAL_PAGE_TYPE } from '@modules/members/historical-applications/constants';

const CapHistoricalNoticesLayout: React.FC = () => (
    <HistoricalSideNavContainer page={HISTORICAL_PAGE_TYPE.NOTICES}>
        <main className="desktop:grid-col-9" id="main-content" data-testid="historical-notices-content">
            <Outlet />
        </main>
    </HistoricalSideNavContainer>
);

export default CapHistoricalNoticesLayout;
